import { StyleSheet } from "react-native";
const style = StyleSheet.create({
    inputContainer: {
        flexDirection: "row",
    },
    inputFt: {
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
        flex: 1,
    },
    inputIn: {
        borderBottomLeftRadius: 0,
        borderLeftWidth: 0,
        borderTopLeftRadius: 0,
        flex: 1,
    },
});
export { style };
